/** First-party branding assets (avoids slow ImgBB on first paint). */
export const DEFAULT_LOGO_URL = '/branding/logo.png';
export const DEFAULT_FAVICON_URL = '/branding/favicon.png';

const EXTERNAL_HOST_RE = /(?:^https?:)?\/\/(?:[^/]*\.)?ibb\.co\b/i;

function r2PublicHostPattern() {
  const base = (process.env.REACT_APP_R2_PUBLIC_BASE_URL || '').trim();
  if (!base) {
    return /(?:^https?:)?\/\/files\.shipdesi\.agrenai\.online\b/i;
  }
  try {
    const host = new URL(base).host.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`(?:^https?:)?//${host}\\b`, 'i');
  } catch {
    return /(?:^https?:)?\/\/files\.shipdesi\.agrenai\.online\b/i;
  }
}

const R2_PUBLIC_HOST_RE = r2PublicHostPattern();

/**
 * Prefer first-party branding when the configured URL is missing or hosted
 * on a slow third-party CDN (ImgBB). R2 public CDN URLs are kept as-is.
 */
export function resolveBrandAssetUrl(url, fallback = DEFAULT_LOGO_URL) {
  return resolveImageUrl(url, fallback);
}

/**
 * Generic image URL resolver for CMS/API content (hero cards, courier logos, blog covers).
 * Returns fallback (default null) for empty or ImgBB hosts; keeps R2 and other URLs.
 */
export function resolveImageUrl(url, fallback = null) {
  if (url == null) return fallback;
  const trimmed = String(url).trim();
  if (!trimmed) return fallback;
  if (R2_PUBLIC_HOST_RE.test(trimmed)) return trimmed;
  if (EXTERNAL_HOST_RE.test(trimmed)) return fallback;
  return trimmed;
}

/** Normalize logo_config / cached logo for header/footer use. */
export function withResolvedLogo(config = {}) {
  const next = { ...(config || {}) };
  next.logo_url = resolveBrandAssetUrl(next.logo_url, DEFAULT_LOGO_URL);
  if (next.favicon_url != null && String(next.favicon_url).trim() !== '') {
    next.favicon_url = resolveBrandAssetUrl(next.favicon_url, DEFAULT_FAVICON_URL);
  }
  return next;
}

export function defaultLogoState(extra = {}) {
  return withResolvedLogo({
    logo_url: DEFAULT_LOGO_URL,
    header_height: 100,
    footer_height: 50,
    sidebar_height: 60,
    auth_height: 110,
    ...extra,
  });
}
